import React, { useState } from "react";
import { Row } from "react-table";
import { StyledRow } from "./styledComponents";
import { TimesheetTabs } from "../../types/Payroll.types";
import { TimesheetsShiftInfo } from "../../types/Shift.types";
import { ShiftDetailsModal } from "./ShiftDetails/ShiftDetailsModal";

export type TableStageRowProps = {
  row: Row<TimesheetsShiftInfo>;
  activeIndex: TimesheetTabs;
  style?: React.CSSProperties;
};
export const TableStageRow = ({ row, activeIndex, style }: TableStageRowProps) => {
  const [rowHoverState, setRowHoverState] = useState(false);
  const [isShiftDetailsModalOpen, setShiftDetailsModalOpen] = useState(false);

  const openModal = () => setShiftDetailsModalOpen(true);
  const closeModal = () => setShiftDetailsModalOpen(false);

  return (
    <>
      <StyledRow
        {...row.getRowProps()}
        onMouseOver={() => setRowHoverState(true)}
        onMouseOut={() => setRowHoverState(false)}
        style={style}
      >
        {row.cells.map((cell) => {
          const cellKey = cell.getCellProps().key;

          return (
            <td {...cell.getCellProps([{ className: cell.column.className }])} key={cellKey}>
              {cell.render("Cell", {
                rowData: { ...row.original },
                activeTabIndex: activeIndex,
                rowHoverState,
                openModal,
              })}
            </td>
          );
        })}
      </StyledRow>

      {isShiftDetailsModalOpen && (
        <ShiftDetailsModal
          isModalOpen={isShiftDetailsModalOpen}
          onCloseModal={closeModal}
          shiftInfo={row.original}
        />
      )}
    </>
  );
};
